import { render, staticRenderFns } from "./ContentTable.vue?vue&type=template&id=8017b2c8&scoped=true&lang=pug&"
import script from "./ContentTable.vue?vue&type=script&lang=js&"
export * from "./ContentTable.vue?vue&type=script&lang=js&"
import style0 from "./ContentTable.vue?vue&type=style&index=0&id=8017b2c8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8017b2c8",
  null
  
)

export default component.exports